import { Box, Skeleton, Stack } from "@mui/material";
import Button from "@mui/material/Button";
import { BodyTextM, cs, HeadingL } from "@repo/ui";
import { Formik } from "formik";
import { type FC } from "react";
import FilterChartsDrawer from "../../Drawer/FilterChartsDrawer";
import Modal from "../../Drawer/Modal";
import Chart from "../Line";
import {
	type fundsFilterType,
	type fundsFormattedType,
	initialValues,
	validationSchema,
} from "./chartCardFunctions";

export interface ChartCardLayoutProps {
	funds: fundsFormattedType;
	isOpen: boolean;
	setIsOpen: (b: boolean) => void;
	data: fundsFormattedType;
	setFormValues: (f: fundsFilterType) => void;
}

const ChartCardLayout: FC<ChartCardLayoutProps> = ({
	funds,
	isOpen,
	setIsOpen,
	data,
	setFormValues,
}) => {
	if (funds.length > 0) {
		return (
			<Formik
				initialValues={initialValues(funds)}
				onSubmit={(values, { setSubmitting }) => {
					setFormValues(values);
					setIsOpen(false);
					setSubmitting(false);
				}}
				validationSchema={validationSchema}
			>
				<Box>
					<Stack
						direction="row"
						justifyContent="space-between"
						alignItems="flex-start"
					>
						<HeadingL>{cs.life.investing.fondsGraphHeading}</HeadingL>
						<Button onClick={() => setIsOpen(true)}>Filtrovat</Button>
						<Modal
							onClose={() => setIsOpen(false)}
							onOpen={() => setIsOpen(true)}
							open={isOpen}
						>
							<FilterChartsDrawer
								handleHideDrawer={() => setIsOpen(false)}
								fundNames={funds ? funds.map(({ name }) => name) : undefined}
							/>
						</Modal>
					</Stack>
					<BodyTextM>
						{cs.life.investing.fondsGraphDescription}
					</BodyTextM>
					<Chart data={data} />
				</Box>
			</Formik>
		);
	}
	return (
		<>
			<Skeleton height={379} />
			Nahrávání grafu fondů trvá zhruba minutu a půl, pracujeme na zlepšení.
		</>
	);
};
export default ChartCardLayout;
